import { createTelegramAIActionHandler } from './ai-action';
import { getTelegramAiMessagePeer } from './telegramAiPeer';
import rootScope from '../../lib/rootScope';
const telegramAiPeerContext = {
  getSelfId: () => rootScope.myId,
  getUser: (id) => rootScope.managers.appUsersManager.getUser(id)
};
let manager = rootScope.managers;
import ListenerSetter from '../../helpers/listenerSetter';
import getPreviewURLFromBytes from '../../helpers/bytes/getPreviewURLFromBytes';
import apiManagerProxy from '../../lib/mtproto/mtprotoworker';
import { avatarUrlToBase64, hasAvatarPhoto } from './avatarData';

import { AppChatsManager } from '../../lib/appManagers/appChatsManager';
import appDialogsManager from '../../lib/appManagers/appDialogsManager';
import { AppManager } from '../../lib/appManagers/manager';
import getProxiedManagers from '../../lib/appManagers/getProxiedManagers';
import { sendMsg, sendText, sendImage, sendImageByBase64 } from './messageUtil';
import { Api_OnlineHeart, clearConfigCache, getConfig } from '../api';
import appImManager from '../../lib/appManagers/appImManager';

import IDBStorage, { IDB } from '../../lib/files/idb';

import tolinkBroadcaster from './TolinkBroadcaster';
import { isTolinkLogin } from './utils';
import { modifyUserInfo } from '../api/authApi';
import { batchReportFans } from '../api/fansApi';
import { reportTelegramMessage } from './chatReport';
import { getMyLang, getTranslateSendSwitch, translateSend } from './translate_util';
import TolinkObservers from './TolinkObservers';
import SecretStore from './SecretStore';
import { CacheTypes, putCache } from './cacheUtil';
import { setPromiseMiddleware } from './PromiseMiddleware';

import { initAiReply } from '../../tolink/utils/AiReply';

import { Send_image_ai } from '../../tolink/auto_reply';
import { Api_TgBot_Report } from '../api/index';
import { sendPayLink } from '../api/fansApi';
import { setWebhookConfig } from './runtimeConfig';

// 消息处理队列和状态跟踪
const messageQueue = [];
const processingMessages = new Set();
const maxConcurrentProcessing = 10; // 最大并发处理消息数
let isProcessingQueue = false;
const failedMessages = new Map(); // 存储失败的消息和重试次数

// 处理消息队列
async function processMessageQueue() {
  if (isProcessingQueue || messageQueue.length === 0 || processingMessages.size >= maxConcurrentProcessing) {
    return;
  }

  isProcessingQueue = true;

  try {
    while (messageQueue.length > 0 && processingMessages.size < maxConcurrentProcessing) {
      const options = messageQueue.shift();
      const messageId = options.message.mid || options.message.id;

      if (processingMessages.has(messageId)) {
        console.log(`~~消息 ${messageId} 正在处理中，跳过重复处理`);
        continue; // 避免重复处理
      }

      processingMessages.add(messageId);
      console.log(`~~开始处理消息 ${messageId}，当前处理中消息数: ${processingMessages.size}`);

      // 处理消息
      processMessage(options).catch(err => {
        console.error(`~~处理消息 ${messageId} 失败:`, err);
        // 添加到失败消息列表，准备重试
        const currentAttempts = failedMessages.get(messageId) || 0;
        if (currentAttempts < 3) { // 最多重试3次
          failedMessages.set(messageId, currentAttempts + 1);
          messageQueue.unshift(options); // 放回队列开头，优先重试
          console.log(`~~消息 ${messageId} 将重试，当前尝试次数: ${currentAttempts + 1}`);
        } else {
          console.error(`~~消息 ${messageId} 重试超过3次，放弃处理`);
        }
      }).finally(() => {
        processingMessages.delete(messageId);
        console.log(`~~消息 ${messageId} 处理完成，当前处理中消息数: ${processingMessages.size}`);
      });
    }
  } finally {
    isProcessingQueue = false;

    // 如果队列中还有消息，且当前处理的消息数未达到上限，继续处理
    if (messageQueue.length > 0 && processingMessages.size < maxConcurrentProcessing) {
      console.log(`~~队列中还有 ${messageQueue.length} 条消息待处理，继续处理`);
      setTimeout(processMessageQueue, 0);
    }
  }
}

// 处理单个消息
async function processMessage(options) {
  const e = options.message;
  console.log(`~~处理消息队列中的消息 ,消息类型：${e._}`, e);

  try {
    // 直接调用AI回复，不再重复验证条件
    await initAiReply(options);
  } catch (error) {
    console.error(`~~AI回复处理失败:`, error);
  }
}

// 定期检查重试失败的消息
setInterval(() => {
  if (failedMessages.size > 0) {
    console.log(`~~尝试重新处理 ${failedMessages.size} 条失败的消息`);
    for (const [messageId, attempts] of failedMessages.entries()) {
      if (attempts < 3) { // 最多重试3次
        // 查找对应的消息
        const messageIndex = messageQueue.findIndex(opt =>
          (opt.message.mid || opt.message.id) === messageId
        );
        if (messageIndex === -1) {
          // 消息不在队列中，放弃处理
          console.log(`~~消息 ${messageId} 不在队列中，放弃处理`);
          failedMessages.delete(messageId);
        }
      } else {
        // 重试超过3次，放弃处理
        console.log(`~~消息 ${messageId} 重试超过限制，放弃处理`);
        failedMessages.delete(messageId);
      }
    }
    // 触发队列处理
    processMessageQueue();
  }
}, 30000); // 每30秒检查一次

console.log('pc---api---222')

let ls = new ListenerSetter();

/**
 * 同步工作号信息，并吞掉失败。
 *
 * 必须 catch：未绑定工作组时请求会被拦在发出之前（见 utils/bridgeRequest.ts），
 * 不接住就是一个未处理的 rejection —— 在控制台刷红，也会污染错误上报。
 * 而这里**不需要**重试：绑定到达时由 `runAfterBindingReady` 统一补发。
 */
function syncUserInfoQuietly() {
  modifyUserInfo().catch((error) => console.warn('同步工作号信息失败（等绑定后补发）', error))
}

ls.add(rootScope)('avatar_update', (e) => {
  console.log(`****avatar_update`, e);
  getUserInfo();
  syncUserInfoQuietly();
});
ls.add(rootScope)('peer_title_edit', (e) => {
  console.log(`****peer_title_edit`, e);
  getUserInfo();
});
ls.add(rootScope)('user_auth', () => {
  console.log(`****LISTENER user_auth`, `user_auth`);
  getUserInfo();
  syncUserInfoQuietly();
});
ls.add(rootScope)('message_sent', (msg) => {
  console.log(`****message_sent`, msg);
  // 内控上报：放在最前面且自己吞异常（见 utils/chatReport.ts）。
  // 这个事件在服务端确认后才派发，所以 msg.message.mid 已是最终值 ——
  // 幂等键稳定，不会因为临时 id 而重复上报
  reportTelegramMessage(msg?.message);
  if (getTranslateSendSwitch()) translateSent(msg);
});

ls.add(rootScope)('message_receive', async (e) => {
  const sourceSelfId = String(rootScope.myId);
  // 内控上报与 AI 回复无关，所以放在**所有 AI 相关判断之前** ——
  // 下面那些 return（AI 未开启、非用户消息、自己的消息、官方消息）都是
  // "不需要 AI 处理"，不是"不需要上报"。放在后面会让上报被它们一并挡掉。
  reportTelegramMessage(e);

  try {
    if (!await getTelegramAiMessagePeer(e, telegramAiPeerContext)) {
      console.log('~~AI仅处理已确认的普通用户私聊，跳过本条消息');
      return;
    }
    // 先检查AI回复状态，如果不是1则不进行后续处理
    const aiReplyStatus = await getAIReplyStatus();
    if (!aiReplyStatus || aiReplyStatus !== 1) {
      console.log(`~~AI回复未开启(状态:${aiReplyStatus})，跳过消息处理`, e);
      return;
    }
    if (String(rootScope.myId) !== sourceSelfId) return;

    console.log(`~~收到用户需处理消息~~ ,消息类型：${e._}`, e);

    const options = { message: e, sourceSelfId };
    const messageId = e.mid || e.id;

    // 将消息加入队列进行处理
    messageQueue.push(options);

    // 触发队列处理
    processMessageQueue();
  } catch (error) {
    console.error('~~message_receive事件处理出错:', error);
  }
});

async function translateSent(msgObj) {
  const msg = msgObj.message;

  const entities = msg.totalEntities;
  const translation = await translateSend(msg.message, getMyLang());

  if (translation) {
    entities.push({
      _: 'messageEntityTextUrl',
      offset: 0,
      length: 0,
      url: `translate-text://translate/${translation ? translation : msg.message
        }`,
    });
    putCache(
      `translate-${msg.peerId}-${msg.id}`,
      CacheTypes.TRANSLATE,
      translation
    );
    console.log(
      `****Translated text and push to entities, with text: ${msg.message}, lang: en, result: ${translation}, entities: ${entities}`
    );
  }
  rootScope.managers.appMessagesManager
    .editMessage(msg, msg.message, {
      entities: entities,
    })
    .then(() => {
      rootScope.dispatchEvent('message_edit', msgObj);
    });
}

async function blobUrlToBase64(blobUrl) {
  return avatarUrlToBase64(blobUrl);
}

export async function setUserInfo2Pc(user) {
  console.log('**setUserInfo2Pc user11111 :>> ', JSON.stringify(user));

  let json = {};

  if (user) {
    const base64 = await getAvatarBase64(user.id, user.photo);
    // 只上报**页面真正掌握**的身份信息（这个账号自身的资料）。
    //
    // 刻意不再上报 token / groupId / groupCode / groupName / groupMemberId /
    // groupMemberMark：那些描述的是「工作号与工作组的绑定关系」，现在由 Dmex 客户端
    // 负责（页面不再自己做绑定）。页面读到的必然是空值，照旧上报会把客户端那边
    // 刚绑定好的信息覆盖成空。
    //
    // 头像只报 base64。**不在这里上传 CDN**：页面侧的上传通道已经不可用
    // （静态 AWS key/secret 不再下发，且服务端的 get_s3_token 回
    // `2008001 upload service is disabled`）。需要 URL 的接口由客户端自己拿 base64
    // 去申请预签名地址上传（见 dmex 的 model/avatar-upload.ts）。
    json = {
      tgUid: user.id,
      tgName: user.first_name + ' ' + (user.last_name ?? ''),
      tgAvatar: base64,
      tgAccount: user.username ?? '',
      tgPhone: user.phone ?? '',
    };
    // console.log("**setUserInfo2Pc4444 :>> ", JSON.stringify(json));
  }

  if (isTolinkLogin()) {
    // const tc = TolinkObservers.get().getDialogsAllUnRead()
    const tc = await getTotalUnreadCount();
    json.totalUnread = tc;
  }

  fetch(`yaychat://set_info`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });
}

export function getUserInfo() {
  rootScope.managers.appUsersManager
    // .getUser()
    .getSelf()
    .then((user) => {
      if (user) {
        setUserInfo2Pc(user);
      }
    });
}

export function cleanUserInfo() {
  setUserInfo2Pc();
}

export async function getUserByPeerId(peerId) {
  return await rootScope.managers.appUsersManager.getUser(peerId);
}

export async function setTyping(peerId) {
  rootScope.managers.appMessagesManager.setTyping(
    peerId,
    { _: 'sendMessageTypingAction' },
    undefined,
    undefined
  );
}

/**
 * AI 应答开关状态的缓存。
 *
 * 真正的请求缓存在 `getConfig` 里（成功 60s / 失败冷却 10s + 并发合并），这里再留一层
 * 是为了连**读缓存**的开销也省掉——`getAIReplyStatus` 在每次 `message_receive` 都会被调。
 *
 * 用户在本页切换开关时由 `toggleAIReply` 同时清掉两层，不需要等 TTL。
 */
const AI_REPLY_STATUS_TTL_MS = 30 * 1000
let aiReplyStatusCache = null

export function toggleAIReply(status) {
  sessionStorage.setItem('aiReplyStatus', status);
  // 本页切换后立即失效：两层缓存都要清，否则要等 TTL 才生效
  aiReplyStatusCache = null
  clearConfigCache()
  console.log('**aiReplyStatus :>> ', status);
}

export async function getAIReplyStatus(status) {
  if (aiReplyStatusCache && Date.now() - aiReplyStatusCache.at < AI_REPLY_STATUS_TTL_MS) {
    return aiReplyStatusCache.value
  }

  try {
    let rsp = await getConfig();
    if (rsp && rsp.code == 200) {
      aiReplyStatusCache = { value: rsp.data.aiReply, at: Date.now() }
      return rsp.data.aiReply;
    }
  } catch (e) {
    console.log(e);
  }
  return sessionStorage.getItem('aiReplyStatus');
}

export function getAIConfig() {
  // fetch(`yaychat://get_config`, {
  //   method: "GET",
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  // });

  sendToPc('yaychat://get_config', null, 'GET');
}

export function setAIConfig(config) {
  if (config) {
    console.log('**config :>> ', config.aiReply);
    sessionStorage.setItem('aiReplyStatus', config.aiReply);
    if (config.aws) {
      SecretStore.getIns().set(SecretStore.KEY_AWS, config.aws);
    }
    if (config.headers) {
      sessionStorage.setItem('headers', JSON.stringify(config.headers));
    }
    // 外部注入的 webhook 地址（见 utils/runtimeConfig.ts）。
    // 没注入时那几处调用点会回退到内置默认值，所以这里是纯可选。
    if (config.webhooks) {
      setWebhookConfig(config.webhooks);
    }
  }
}

export function setHasRead(msg) {
  console.log('设置消息已读 :>> ');
  let peerId = msg.peerId;
  let msgIds = [];
  msgIds.push(msg.mid);
  console.log('**peerId :>> ', peerId);
  console.log('**msgIds :>> ', msgIds);
  // rootScope.managers.appMessagesManager.readMessages(peerId, msgIds);

  rootScope.managers.appMessagesManager.readHistory(peerId, msg.mid);
}

export async function setActiveUser(peerId) {
  let res = await getUserByPeerId(peerId);
  console.log('** RES yaychat://set-active-user :>> ', res);
  sendToPc('yaychat://set-active-user', res);
}

export async function getConvs({ type, status, keyword }) {
  console.log('**getConvs :>> ');
  // let indexDb = await rootScope.managers.appStoragesManager.loadStorages();
  let idb = new IDBStorage({ name: 'tweb' });
  // let users = indexDb.users;
  // let chats = indexDb.chats;
  let users = await idb.getAll('users');
  let chats = await idb.getAll('chats');
  let dialogs = await idb.getAll('dialogs');
  let indexDb = { idb: idb, users: users, chats: chats, dialogs: dialogs };
  let arr = filterDialogs(indexDb, type, status, keyword);

  let userInfoArr = [];

  for (var item of arr) {
    let type = item.peer._;
    if (type == 'peerChat') {
      let chat = chats.find((c) => {
        return c.id == item.peer.chat_id;
      });
      if (chat) {
        let base64 = await getAvatarBase64(item.peerId, chat.photo);
        let obj = {
          id: chat.id,
          avatar: base64,
          name: chat.title,
          userName: chat.username,
          time: item.topMessage?.date ?? Date.now(),
        };
        userInfoArr.push(obj);
      }
    } else if (type == 'peerUser') {
      let user = users.find((u) => {
        return u.id == item.peerId;
      });
      if (user) {
        let base64 = await getAvatarBase64(item.peerId, user.photo);
        let obj = {
          id: user.id,
          avatar: base64,
          name: user.first_name + ' ' + (user.last_name ?? ''),
          userName: user.username,
          time: item.topMessage?.date ?? Date.now(),
        };
        userInfoArr.push(obj);
      }
    } else if (type == 'peerChannel') {
      let chat = chats.find((c) => {
        return c.id == item.peer.channel_id;
      });
      if (chat) {
        let base64 = await getAvatarBase64(item.peerId, chat.photo);
        let obj = {
          id: chat.id,
          avatar: base64,
          name: chat.title,
          userName: chat.username,
          time: item.topMessage?.date ?? Date.now(),
        };
        userInfoArr.push(obj);
      }
    }
  }

  console.log('**userInfoArr :>> ', userInfoArr);
  return userInfoArr;
}

async function getAvatarBase64(peerId, photo) {
  if (!hasAvatarPhoto(photo)) return '';
  try {
    const avatarUrl = await apiManagerProxy.loadAvatar(peerId, photo, 'photo_small');
    return await blobUrlToBase64(avatarUrl);
  } catch {
    return '';
  }
}

function filterDialogs(indexDb, type, status, keyword) {
  let allDialogs = indexDb.dialogs;
  console.log('allDialogs---', JSON.stringify(allDialogs));
  let arr = [];
  if (type == 0) {
    arr = allDialogs;
  }
  if (type == 1) {
    arr = allDialogs.filter((item) => {
      return item.peer._ == 'peerUser';
    });
  }
  if (type == 2) {
    arr = allDialogs.filter((item) => {
      return item.peer._ == 'peerChat';
    });
  }
  if (type == 3) {
    arr = allDialogs.filter((item) => {
      return item.peer._ == 'peerChannel';
    });
  }

  if (status == 0) {
    arr = arr;
  }
  if (status == 1) {
    arr = arr.filter((item) => {
      return item.unread_count > 0;
    });
  }

  if (status == 2) {
    arr = arr.filter((item) => {
      return item.topMessage.fromId == item.topMessage.peerId;
    });
  }

  if (status == 3) {
    arr = arr.filter((item) => {
      return (
        item.unread_count == 0 &&
        item.topMessage.fromId != item.topMessage.peerId
      );
    });
  }

  return arr;
}

async function parceEntries(array) {
  const promises = array.map(async (item) => {
    // let avatar = await doSomethingAsync(item);
    let avatarDomStr = item[1].dom.avatarEl.element.innerHTML;
    const regex = /src=\"(.*?)\"/;
    const match = avatarDomStr.match(regex);
    const src = match ? match[1] : null;
    return await blobUrlToBase64(src);
  });
  await Promise.all(promises);
}

function sendToPc(flag, data, method = 'POST') {
  if (method == 'POST') {
    console.log('**sendToPc :>> post', data);
    fetch(flag, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data }),
    });
  } else {
    console.log('**sendToPc :>> GET', data);

    fetch(flag, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

export function getIndexDB() {
  rootScope.managers.appStoragesManager.loadStorages().then((res) => {
    console.log('******************* :>> ', res.dialogs);
  });
}
export function setTransCfg(config) {
  if (config.receive != null) {
    localStorage.setItem('translate-receive', config.receive);
  }

  if (config.send != null) {
    localStorage.setItem('translate-send', config.send);
    tolinkBroadcaster.emit({
      event: 'translate:send:changed',
      data: config.send
    })
  }
}

export function getTransCfg() {
  const receive = '1' === localStorage.getItem('translate-receive');
  const rend = '1' === localStorage.getItem('translate-send');

  return { receive: receive ? 1 : 0, send: rend ? 1 : 0 };
}

export function setFansTransLan(tgId, lan) {
  if (tgId != null && lan != null) {
    localStorage.setItem(`${tgId}-translate-lang`, lan);
  }
}

export function getFansTransLan(tgId) {
  if (tgId != null) {
    return localStorage.getItem(`${tgId}-translate-lang`);
  }
  return null
}

export function bringToInput(content) {
  rootScope.dispatchEvent('set_input', content);
}

export function sendToChat(data) {
  console.log('**sendToChat==', JSON.stringify(data));
  sendMsg(data.type, data.content);
}

window.manualSendPaylink = manualSendPaylink

function manualSendPaylink() {
  sendPayLink(appImManager.chat.peerId, true)
}

async function groupSend(data) {
  console.log('**groupSend :>> ', 'groupSend');
  console.log('**groupSend 触发时间:>> ', Date.now());
  let { targetIds, msgDuration, dialogDuration, content } = data;

  let msg_rd_min = parseInt(msgDuration.split('-')[0]);
  let msg_rd_max = parseInt(msgDuration.split('-')[1]);

  let dialog_rd_min = parseInt(dialogDuration.split('-')[0]);
  let dialog_rd_max = parseInt(dialogDuration.split('-')[1]);

  for (const peerId of targetIds) {
    await singleSendMsgDelay(peerId, content, msg_rd_min, msg_rd_max);

    // 计算两个用户之间的随机延迟
    let dialogDelay =
      Math.floor(Math.random() * (dialog_rd_max - dialog_rd_min + 1)) +
      dialog_rd_min;
    await new Promise((resolve) => setTimeout(resolve, dialogDelay * 1000));
  }
  console.log('**groupSend 结束时间:>> ', Date.now());
  return true;
}

function singleSendMsgDelay(peerId, content, msg_rd_min, msg_rd_max) {
  return new Promise((resolve) => {
    console.log('**singleSendMsgDelay for peerId:>> ', peerId);
    console.log('**singleSendMsgDelay 触发时间:>> ', Date.now());
    let totalDelay = 0;
    msg_rd_min = parseInt(msg_rd_min);
    msg_rd_max = parseInt(msg_rd_max);

    content.forEach((msgItem, index) => {
      let rd_s =
        Math.floor(Math.random() * (msg_rd_max - msg_rd_min + 1)) + msg_rd_min;
      totalDelay += rd_s;

      setTimeout(() => {
        console.log('**singleSendMsgDelay 单条消息 触发时间:>> ', Date.now());
        if (msgItem.type == '1') {
          sendText(peerId, msgItem.content);
        } else if (msgItem.type == '2') {
          sendImageByBase64(peerId, msgItem.base64);
        }

        if (index === content.length - 1) {
          resolve(); // 解决 Promise 当所有消息发送完毕
        }
      }, totalDelay * 1000);
    });
  });
}

async function delConv(peerId) {
  try {
    // rootScope.dispatchEvent("del_convs");
    let indexDb = await rootScope.managers.appStoragesManager.loadStorages();
    let users = indexDb.users;
    console.log('**delConv :>> ', peerId);

    let arr = [];
    // for (let k of users) {
    //   arr.push(String(k));
    // }
    users.forEach((item) => {
      arr.push(String(item.id));
    });
    console.log('**del arr :>> ', arr);
    if (arr.indexOf(String(peerId)) > -1) {
      console.log('**del 普通用户 :>> ', peerId);
      await rootScope.managers.appMessagesManager.flushHistory(
        Number(peerId),
        false,
        true
      ); //删普通用户
    } else {
      console.log('**del 群组 channel :>> ', peerId);
      await rootScope.managers.appChatsManager.delete(Number(peerId));
    }
    // rootScope.managers.appMessagesManager.flushHistory(peerId, false); //删普通用户
    // rootScope.managers.appChatsManager.delete(peerId); //删群组
    rootScope.managers.dialogsStorage?.dropDialog(Number(peerId));
  } catch (e) {
    return Promise.reject('无权限，删除失败，请重新检查!!');
  }
  return Promise.resolve(true);
}

async function delConvs(ids) {
  console.log('**delConv :>> ', ids);
  for (let index = 0; index < ids.length; index++) {
    const peerId = ids[index];
    await delConv(Number(peerId));
  }
  return Promise.resolve(true);
}

let timer = null;
function setHeartCheck() {
  if (timer) return;
  timer = setInterval(() => {
    console.log('**setHeartCheck :>> ', Date.now());
    // 必须 catch：未绑定工作组时心跳会被拦下（见 utils/bridgeRequest.ts），
    // 不接住就是每 30 秒一个未处理 rejection。
    // 定时器本身不受影响，绑定完成后下一拍就正常了，所以这里不需要重试。
    Api_OnlineHeart().catch(() => {});
  }, 30000);
}

async function getHistoryByPeerId(peerId) {
  return await rootScope.managers.appMessagesManager.getHistoryMessagesStorage(
    peerId
  );
}

async function loadDialogs(peerId) {
  let peer = await rootScope.managers.appPeersManager.getInputPeerById(peerId);

  const historyResult = await rootScope.managers.appMessagesManager.getHistory({
    peerId: peerId,
    limit: 1000,
  });
  console.log('**historyResult :>> ', historyResult);
  // console.log("**res :>> ", res);
  // let f = AppDialogsManager.xd;
  // let res = await f.onChatsScroll();
  // let r = await res.renderPromise;
  // console.log("**f :>> ", r);
  // let res = await rootScope.managers.apiManager.invokeApi({
  //   method: "messages.getHistory",
  //   params: {
  //     peerId: peerId,
  //     limit: 1000,
  //   },
  // });
  let res = await rootScope.managers.apiManager.invokeApi(
    'messages.getHistory',
    {
      peer: peer,
      limit: 1000,
    }
  );
  console.log('**res :>> ', res);
}

async function bot_sendMessage(chat_id, text) {
  // https://api.telegram.org/bot123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11/getMe
  Api_TgBot_Report({
    chat_id: import.meta.env.VITE_BASE_YAYNIGHT_PEER_ID,
    text,
  });

  Api_TgBot_Report({
    chat_id: import.meta.env.VITE_BASE_YAYNIGHT_PEER_ID2,
    text,
  });
}

window.loadDialogs = loadDialogs;
window.setHeartCheck = setHeartCheck;
window.getAIConfig = getAIConfig;
window.getAIReplyStatus = getAIReplyStatus;
window.toggleAIReply = toggleAIReply;
window.getUserInfo = getUserInfo;
window.setTyping = setTyping;
window.setHasRead = setHasRead;
window.setUserInfo2Pc = setUserInfo2Pc;
window.setAIConfig = setAIConfig;

window.setTransCfg = setTransCfg; // 设置翻译开关
window.getTransCfg = getTransCfg; // 获取翻译开关
window.setFansTransLan = setFansTransLan; // 设置翻译语言
window.getFansTransLan = getFansTransLan; // 获取翻译语言

window.setActiveUser = setActiveUser; //查询到用户信息给客户端
window.getConvs = getConvs; //查询到用户信息给客户端

window.bringToInput = bringToInput; // 设置输入框内容
window.sendToChat = sendToChat; // 发送私聊消息

window.groupSend = groupSend; // 群发消息
window.clearUserInfo = cleanUserInfo;
window.delConvs = delConvs;
window.Send_image_ai = Send_image_ai;
window.toggleNSFW = toggleNSFW;
window.isNSFWEnable = () => {
  return localStorage.getItem('tlk.nsfw') == '1';
}

window.tolinkInit = (params) => {
  console.log('tolinkInit')
  try {
    if (typeof params == 'object') {
      sessionStorage.setItem('.__tg.larkid', params.larkid)
      sessionStorage.setItem('.__tg.larkname', params.larkname)
    } else if (typeof params == 'string') {
      let obj = JSON.parse(params)
      sessionStorage.setItem('.__tg.larkid', obj.larkid)
      sessionStorage.setItem('.__tg.larkname', obj.larkname)
    }
  } catch (error) {
    console.error('tolinkInit error', error)
  }
}

/**
 * 当前选中的工作流编码（`workflowCode`）。
 *
 * 原先是 `setCozeBotId` / `getCozeBotId` 配 `.tweb.botId` —— Coze 相关命名已整体废弃，
 * 键名一并改掉。
 *
 * **带一次性兼容**：旧的 `.tweb.botId` 里可能还存着用户选过的工作流。直接改名会让它
 * 在用户重新选择之前一直为空（AI 应答会静默停掉），所以读到旧值就迁移过来。
 */
window.setWorkflowCode = (workflowCode) => {
  localStorage.setItem('.tweb.workflowCode', workflowCode)
}

window.getWorkflowCode = () => {
  const current = localStorage.getItem('.tweb.workflowCode')
  if (current) return current
  const legacy = localStorage.getItem('.tweb.botId')
  if (legacy) {
    localStorage.setItem('.tweb.workflowCode', legacy)
    return legacy
  }
  return ''
}

/**
 * 接收 Dmex 客户端下发的工作组绑定信息。
 *
 * 为什么需要：页面自己不再做绑定（见 tolink/api/authApi.ts 的说明），而 AI 应答
 * 请求要带上工作组参数（`workgroupCode` / `workgroupName` / `groupMemberId`，
 * 见 tolink/utils/AiReply.ts）。这些值现在只有客户端知道，必须由它下发。
 *
 * 沿用原来的 sessionStorage 键名，这样 AiReply.ts 等读取处一行都不用改 ——
 * 变的只是值的来源。
 *
 * 这份信息同时是**业务请求的准入条件**（见 utils/bridgeRequest.ts）：
 * 没有 `tolink_groupMemberId` 时所有 dmex 业务接口都会被拦下，不发出去。
 */
window.setTolinkBinding = (binding) => {
  try {
    const info = typeof binding === 'string' ? JSON.parse(binding) : binding
    if (!info || typeof info !== 'object') return

    // 逐字段写入：某个字段缺失时清掉它，而不是留着上一次的旧值 ——
    // 换绑到别的工作组时留着旧组名，比留空更容易让人误判
    sessionStorage.setItem('tolink_groupCode', info.groupCode ?? '')
    sessionStorage.setItem('tolink_groupName', info.groupName ?? '')
    sessionStorage.setItem('tolink_groupMemberId', info.memberId ?? '')
    sessionStorage.setItem('tolink_groupId', info.groupId ?? '')

    // 绑定前被拦下的请求会在 getConfig 里留下"失败"缓存（冷却 10 秒）。
    // 绑定刚到就清掉，否则用户要干等一个冷却周期才见到功能恢复。
    clearConfigCache()

    console.log('**setTolinkBinding :>> ', info.groupCode)

    // 只在真的拿到成员 id 时才跑，避免拿着空上下文再打一遍注定被拦的请求
    if (info.memberId) runAfterBindingReady()
  } catch (error) {
    console.error('setTolinkBinding error', error)
  }
}

/**
 * 绑定就绪后补跑那些「启动时被拦下、而且自己不会重试」的同步。
 *
 * 为什么必须有这一步：业务请求在未绑定时会被拦在发出之前
 * （见 utils/bridgeRequest.ts），而下面这两件事都是**一次性**触发的 ——
 * 它们发生在登录流程里，那时绑定信息还没下发。被拦掉之后：
 *
 *  · `modifyUserInfo`：由登录事件触发，且自带 1 秒合并窗口，紧随的重试也会被跳过
 *    → 工作号的头像、昵称再也同步不上去；
 *  · `batchReportFans`：页面挂载时跑一次，之后**每小时**一次
 *    → 后台「聊天记录」里对端就只剩一串 id（昵称头像的唯一来源是粉丝资料）。
 *
 * 逐个去改调用点是在打地鼠，所以集中放在这里：绑定到达是这些请求**第一次可能成功**
 * 的时刻。新增「启动时同步」的功能时，记得一并加进来。
 */
function runAfterBindingReady() {
  // 强制补发：绕过 modifyUserInfo 自己的 1 秒合并窗口
  modifyUserInfo(true).catch((error) => console.warn('绑定后同步工作号信息失败', error))

  // 粉丝资料：后台把对端 id 翻成人名头像全靠它。内部已自行吞掉异常
  batchReportFans({ refreshProfiles: true })
}

/**
 * 消费客户端**在本模块加载之前**就放好的绑定信息。
 *
 * 为什么需要：注入时机和 bundle 的执行时机没有先后保证 —— 客户端在 webview
 * `dom-ready` 时注入，而那一刻 tweb 的 JS 可能还没执行到上面这行定义，
 * `window.setTolinkBinding` 还是 undefined，那次下发就**静默丢失**了。
 *
 * 所以约定客户端先把值写进 `window.__dmexBinding`（无论函数在不在），再尝试调用函数。
 * 两种顺序就都成立了：
 *  · 客户端先到 → 这里补上一次消费；
 *  · 页面先到 → 客户端那次直接调用生效。
 *
 * 字段映射只有上面那一处，不会因为两条路径而分叉。
 */
if (window.__dmexBinding) {
  window.setTolinkBinding(window.__dmexBinding)
}

/**
 * 接收 Dmex 客户端下发的头像公开地址。
 *
 * 为什么由客户端给：`group-member/modify` 的 `sysAvatar` 要的是 **URL**，而页面自己
 * 已经没有上传通道了 —— 静态 AWS key/secret 不再下发（客户端 store 里的 `aws` 只剩
 * `region`），旧的 `get_s3_token` 服务端也回 `2008001 upload service is disabled`。
 * 新的直传接口要鉴权，凭据只有客户端有，所以上传由它做、结果下发给页面。
 */
window.setTolinkAvatarUrl = (url) => {
  try {
    sessionStorage.setItem('tolink_avatarUrl', typeof url === 'string' ? url : '')
  } catch (error) {
    console.error('setTolinkAvatarUrl error', error)
  }
}

// 消费客户端在本模块加载之前放好的值，理由同 __dmexBinding
if (typeof window.__dmexAvatarUrl === 'string') {
  window.setTolinkAvatarUrl(window.__dmexAvatarUrl)
}

window.setTargetLans = (lans) => {
  localStorage.setItem('.tweb.targetLans', JSON.stringify(lans))
}

window.__dmexAIActionCapabilities = { version: 1, media: ['image', 'video', 'voice'] };
window.triggerAction = createTelegramAIActionHandler({
  getManager: () => rootScope.managers.appMessagesManager,
  getSelfId: () => rootScope.myId,
  getUser: (id) => rootScope.managers.appUsersManager.getUser(id)
});


function toggleNSFW() {
  const nsfw = localStorage.getItem('tlk.nsfw');
  if (nsfw == '1') {
    localStorage.setItem('tlk.nsfw', '0');
  } else {
    localStorage.setItem('tlk.nsfw', '1');
  }
}

window.test = async () => {
  let a = await getTotalUnreadCount();
  console.log('test===>', a);
};

getAIConfig();

tolinkBroadcaster.addCallback((e) => {
  console.log('TolinkBroadcaster----', e);
  if (isTolinkLogin()) {
    switch (e.event) {
      case 'db:change':
        handleDBChange(e.data);
        break;
    }
  }
});

// TolinkObservers.get().observerDialogs()

/**
 * {
        key: entryName,
        value: value,
        storeName: storeName ?? this.storeName
    }
 * @param {} data 
 */
function handleDBChange(data) {
  if (data) {
    if (data.storeName == 'dialogs') {
      // 列表有更新
      refreshUnreadToPc();
    }
  }
}

async function refreshUnreadToPc() {
  if (IDB.hasInstance('tweb')) {
    const count = await getTotalUnreadCount();
    fetch(`yaychat://update_unread`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        totalCount: count,
      }),
    });
  }
}

const promiseMiddlewareDom = {};
async function getTotalUnreadCount() {
  if (IDB.hasInstance('tweb')) {
    const idb = new IDBStorage({ name: 'tweb' });
    const allDialogs = await idb.getAll('dialogs');
    const { deferred, middleware } = setPromiseMiddleware(
      promiseMiddlewareDom,
      'getTotalUnreadCount'
    );
    if (allDialogs) {
      let totalCount = 0;
      for (let index = 0; index < allDialogs.length; index++) {
        const dialog = allDialogs[index];
        const isTopic = dialog._ === 'forumTopic';
        const { peerId } = dialog;
        const promise = Promise.all([
          peerId.isAnyChat() && !isTopic
            ? getProxiedManagers()
              .acknowledged.dialogsStorage.getForumUnreadCount(peerId)
              .then((result) => {
                if (result.cached) {
                  return result.result;
                } else {
                  return { count: 0, hasUnmuted: false };
                }
              })
              .catch(() => { })
            : undefined,
        ]);

        let [forumUnreadCount] = await middleware(promise);
        const { count: unreadTopicsCount, hasUnmuted: hasUnmutedTopic } =
          forumUnreadCount || {};
        const unreadCount = unreadTopicsCount ?? dialog.unread_count;
        totalCount += unreadCount;
      }
      return totalCount;
    }
  }
  return 0;
}

window.testSendPayLink = (id) => {
  sendPayLink(id)
}
